import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, take } from 'rxjs/operators';

import { AuthService } from '@account-users';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public get profile() {
    return this.auth.profile;
  }

  public get isAuthenticated() {
    return this.auth.isAuthenticated();
  }

  constructor(
    public readonly auth: AuthService,
    private readonly router: Router,
    private readonly pageTitle: Title,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    auth.handleAuthentication();
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
      )
      .subscribe((event) => {
        const { data } = event.snapshot;
        this.pageTitle.setTitle(
          data['title'] ? data['title'] : 'One Back Office',
        );
      });
  }

  public login() {
    this.auth.login();
  }

  public logout() {
    this.auth.logout();
  }
}
